module.exports = __webpack_public_path__ + "static/img/hover-iocn2.bf50a98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn2.svg
// module id = z36l
// module chunks = 3